import styled, { css } from 'styled-components';
import { Loader } from 'src/components';
import { ActorFace } from 'src/components/ActorFace';

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s6};
    width: 100%;
    max-width: ${theme.sz.sm};
    margin: 0 auto;
    padding: ${theme.sz.s6} ${theme.sz.s4};
    box-sizing: border-box;
    color: ${theme.co.neutral10};
  `,
);

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: ${theme.sz.s2};
  `,
);

export const BackButton = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};
    margin: 0;
    padding: 0;
    border: none;
    border-radius: ${theme.bo.round};
    background: none;
    color: inherit;
    font-size: ${theme.sz.s6};
    cursor: pointer;
  `,
);

export const HeaderTitle = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xs};
  `,
);

export const Profile = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s4};
  `,
);

export const ProfileFace = styled(ActorFace)(
  ({ theme }) => css`
    width: ${theme.sz.s24};
    height: ${theme.sz.s24};
    border: none;
  `,
);

export const Name = styled.h1(
  ({ theme }) => css`
    margin: 0;
    ${theme.typography.heading.mobile.m};
  `,
);

export const Stats = styled.p(
  ({ theme }) => css`
    margin: ${theme.sz.s1} 0 0;
    ${theme.typography.paragraph.base};
  `,
);

export const Grid = styled.ul(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: ${theme.sz.s1};
    margin: 0;
    padding: 0;
    list-style: none;
  `,
);

export const BookmarkInfo = styled.p(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    gap: ${theme.sz.s2};
    margin: 0;
    color: ${theme.co.neutral40};
    ${theme.typography.paragraph.m};

    svg {
      flex-shrink: 0;
      width: ${theme.sz.s4};
      height: ${theme.sz.s4};
      margin-top: ${theme.sz.s05};
    }
  `,
);

export const BookmarkNotification = styled.div(
  ({ theme }) => css`
    position: fixed;
    inset-inline: ${theme.sz.s4};
    bottom: calc(${theme.sz.s6} + env(safe-area-inset-bottom, 0px));
    z-index: ${theme.zi.tooltip};
    max-width: ${theme.sz.sm};
    margin-inline: auto;
  `,
);

export const ProfileLoader = styled(Loader)(
  ({ theme }) => css`
    margin: ${theme.sz.s6} auto;
  `,
);

export const Message = styled.p(
  ({ theme }) => css`
    margin: 0;
    text-align: center;
    ${theme.typography.paragraph.base};
  `,
);

export const Player = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};
    width: 100%;
    height: 100dvh;
    padding: ${theme.sz.s4};
    box-sizing: border-box;
    background-color: ${theme.co.neutral0};
    color: ${theme.co.neutral99};
  `,
);

export const PlayerVideo = styled.video(
  ({ theme }) => css`
    flex: 1;
    min-height: 0;
    width: 100%;
    border-radius: ${theme.bo.small};
    object-fit: contain;
  `,
);

export const PlayerCaption = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const PlayerLearnable = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.s};
  `,
);

export const PlayerTranslation = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
  `,
);
